import { render, staticRenderFns } from "./InventoryLabResultForm.vue?vue&type=template&id=1351f640"
import script from "./InventoryLabResultForm.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports